
<v-app id="inspire">
	<admin-nav-drawer v-model="drawer"></admin-nav-drawer>

	<v-app-bar app color="#F6F6F6" dense flat>
		<!--v-app-bar-nav-icon  @click.stop="drawer = !drawer"></v-app-bar-nav-icon-->
		<v-toolbar-title no-gutters>
			<a href="https://www.locumbase.com" target="_blank">
				<v-img :src="require('@/assets/images/logos/logo-color.png')" max-width="195" min-width="100" contain />
			</a>
		</v-toolbar-title>

		<v-tabs v-if="$vuetify.breakpoint.mdAndUp" color="secondary" centered center-active>
			<v-tab href="https://admin.locumbase.com" target="_blank" router class="text-none font-weight-bold">New Admin Dashboard</v-tab>
		</v-tabs>

		<v-spacer></v-spacer>

		<admin-nav-drawer></admin-nav-drawer>

		<v-app-bar-nav-icon color="secondary" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
	</v-app-bar>
	<!-- END of Toolbar -->

	<v-main>
		<v-container class="mt-2" fluid>
			<router-view />
			<!--slot / -->
		</v-container>
	</v-main>

	<v-footer app>
		<span>&copy; {{ new Date().getFullYear() }}</span>
	</v-footer>
</v-app>
